<template>
<!-- 首页 -->
  <div id="home">
    <h3c-header></h3c-header>
    <h3c-sidebar ref="sidebar" @on-change="tagShow" :routerForm='routerForm'></h3c-sidebar> 
    <div class="contentWrap">
      <!-- <tagList :tagName="tagCurrent" v-on:on-close="tagClose"></tagList> -->
        <transition name="move" mode="out-in">
          <!-- <router-view></router-view>  -->
          <!-- <h3c-tagList></h3c-tagList> -->
         <tagList></tagList>
        </transition>
    </div>
    
  </div>
</template>

<script>
import h3cHeader from '@/components/public/header'
import h3cSidebar from '@/components/public/sidebar'
import tagList from '@/components/public/tabs'

export default {
  components: {h3cSidebar,h3cHeader, tagList},
  data () {
    return {
      routerForm: '',
      once: 0,
      dom: 0,
      routeChange: false
    }
  },
  methods:{
    tagShow: function (data) { 
        this.$store.commit('tagChange', data)  
    },
    executeOnce () {
      this.once++
      if (this.once === 1) {
        setTimeout(() => {
          Array.prototype.some.call(document.querySelectorAll('.ivu-menu-item'), (it) => {
            if (it.innerText.replace(/(^\s*)|(\s*$)/g, '') === this.dom) {
              it.classList.remove('ivu-menu-item-active')
              it.classList.remove('ivu-menu-item-selected')
            }
          })
        }, 500)
      }
    },

     heightLight () {
      // 改为调用 sidebar 的 refreshMenu，使用 iView 官方方法展开/高亮菜单，
      // 避免直接操作 DOM 被 v-show 还原导致父级菜单收起
      if (this.$refs.sidebar && this.$refs.sidebar.refreshMenu) {
        this.$refs.sidebar.refreshMenu()
      }
    }
  },

  watch: {
      $route (to, from) {
         if (to.path.split('/')[1] !== 'indexw') {
             this.heightLight()
          }
          var menu = this.$route.fullPath.split('/')[1]
          var subMenu = ''
          if (this.$route.fullPath.split('/')[2] !== this.$store.state.tabOpen) {
            subMenu = this.$route.fullPath.split('/')[2]
          } else {
            subMenu = ''
          }
         this.$store.commit('subMenuSet', subMenu)
         this.$store.commit('menuSet', menu)
         var allMenuList = this.$store.state.allMenuList;
         if(allMenuList.indexOf(to.name) > -1) {
            this.$store.commit('tagChange', to.name)
            // this.$store.commit('tabSwitch', to.name)
         }
        //  for (var val of allMenuList) {               
        //    if(val.nodes !=='undefine' && val.nodes !== ''){
        //       for (var val2 of val.nodes) { 
        //         if(val2.nodes !=='undefine' && val2.url === to.name ){
        //           this.$store.commit('tagChange', to.name)
        //           this.$store.commit('tabSwitch', to.name)
        //         }
        //       }
        //     }
        //   }
      }
  },
  computed: {
    homeType () {
      return this.$store.state.homePageType
    }
  },
  created(){
    let islhToken = sessionStorage.getItem('islhtoken');
    if(!islhToken){
      this.$router.push('/login');
      this.$store.commit('tagChange', 'login');
    }
  },

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" type='text/less'>
@import "../../../static/css/common.css";
#home{
  width:100%;
  height:100%;
  .contentWrap{
    width:e("calc(100% - 240px)");
    // height:e("calc(100% - 70px)");
    position: absolute;
    top:70px;
    left:240px;
    background:white;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/login/indexw.vue